import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import locale from 'antd/lib/locale/es_ES';
import { AwsContextProvider } from './app/context/aws/awsProvider';
import App from './App';
import generateStore from './app/redux/store';

import reportWebVitals from './reportWebVitals';
import 'moment/locale/es-mx';

const { store, persistor } = generateStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ConfigProvider locale={locale}>
          <AwsContextProvider>
            <App />
            <ToastContainer limit={1} />
          </AwsContextProvider>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
